import React from "react";
import CryptoJS from "crypto-js";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import $ from "jquery";
import Modal from "./Modal";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
import API from "@aws-amplify/api";
import "assets/scss/styles.css";
import Parser from "html-react-parser";

let apiName = process.env.REACT_APP_AMPLIFY_API;

class AddRule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localStorageClientId: "",
    };
  }

  componentDidMount() {
    this.setState({
      localStorageClientId: this.decryptLocal("clientId"),
    });
  }

  decryptLocal(item_id) {
    return JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem(item_id),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )
  }

  deleteRuleClick(selectedRule) {
    this.props.dispatch({
      type: "CUST_TILL_SQL_POP",
      selectedIndex: this.props.index,
      selectedRule: selectedRule,
    });
    this.props.dispatch({ type: "CUST_Add" });
    if (
      this.props.cust_tillSqlSelectionArr.length == 0 &&
      this.props.cust_afterSqlSelectionArr == 0 &&
      this.props.cust_ruleLeveltoggle == 0 &&
      this.props.cust_groupLeveltoggle == 0
    ) {
      this.props.dispatch({
        type: "CUST_UPDATE_OVERLAY_SPINNER",
        overlaySpinner: true,
      });
      let fQS = "";
      if (this.state.localStorageClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9") {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter((obj) => obj.id === this.decryptLocal("activeChannel"))[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          this.decryptLocal("globalFilter") +
          " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)";
      } else {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter(
            (obj) =>
              obj.id ===
              this.decryptLocal("activeChannel")
          )[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          this.decryptLocal("globalFilter");
      }
      let myInitCount = {
        headers: {},
        body: {
          sql: fQS,
          isGeneral: true,
          custDb: this.decryptLocal("custDb"),
        },
      };

      API.post(apiName, "/counts", myInitCount)
        .then((response) => {
          this.prepareQueryResponse(response);
          //this.prepareQueryData(response);
          //this.setState({loadingInitalSpinner : 'false'});
        })
        .catch((error) => {
          console.log("Error", error);
        });
    }
  }

  fetchProspectQueryData(
    modelDecileCondition,
    nonModelDecileCondition,
    samplingCondition
  ) {
    // console.log("fetch Prospect Query Data Called");
    // console.log("Model Decile Condition " + modelDecileCondition);
    // console.log("Non Model Decile Condition " + nonModelDecileCondition);
    // console.log("Samppling Condition " + samplingCondition);

    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: true,
    });

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    if (selectedCustomerType === "Acquistion") {
      // Set Channels
      let channel = "display";
      if (
        this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
        this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
      ) {
        channel = "email";
      }
      if (this.decryptLocal("activeChannel") === "2c77a7b6-60e9-4c75-819e-e93b60d47b82") {
        channel = "direct_mail";
      }

      fetch(
        "https://v56uvo3jhtilsarixxweiwahum0nrabn.lambda-url.us-west-2.on.aws/",
        {
          method: "post",
          body: JSON.stringify({
            maximumAudienceSizeParameterValue: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("maximumAudienceSizeLocalStorage"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            prospectMinimumParameterValue: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("prospectMinimumValueLocalStorage"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            channelType: channel,
            nonModelDecileProspectFilterRule: nonModelDecileCondition,
            modelDecileProspectFilterRule: modelDecileCondition,
            samplingFilterRule: samplingCondition,
            clientName: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("conceptName"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            selectedType: "filter",
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          console.log("Result", result);
          if (result.hasOwnProperty("ERROR")) {
            this.setState(
              {
                errorFlag: true,
              },
              () => {
                this.setState({
                  overlaySpinnerSummary: false,
                });
              }
            );
          } else {
            this.prepareProspectQueryResponse(result);
          }
        });
    }
  }

  fetchQueryData(fQS) {
    let myInitCount = {
      headers: {},
      body: {
        sql: fQS,
        isGeneral: true,
        custDb: this.decryptLocal("custDb"),
      },
    };

    console.log(fQS);

    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: true,
    });
    API.post(apiName, "/counts", myInitCount)
      .then((response) => {
        /*this.props.dispatch({
        type: "CUST_UPDATE_QUERY_COUNT",
        query_count: " ",
        full_count: " ",
        address_count: " ",
        email_count: " ",
        preview: []
      });*/
        this.props.dispatch({
          type: "CUST_UPDATE_SUMMARY_DETAILS",
          filterTabPayload: fQS,
          filterTabValue: response,
        });
        this.prepareQueryResponse(response);
        //this.prepareQueryData(response);
      })
      .catch((error) => {
        this.props.dispatch({
          type: "CUST_UPDATE_QUERY_COUNT",
          query_count: " ",
          full_count: " ",
          address_count: " ",
          email_count: " ",
          preview: [],
          total_audience_email_count: " ",
          total_audience_email_pre: " ",
          total_audience_email_eclub: " ",
          total_non_mkt: " ",
          total_mkt: " ",
          non_eclub_emails: " ",
          non_preclub_emails: " ",
          non_email_custs: " ",
          non_direct_mail: " ",
        });
      });
  }

  prepareProspectQueryResponse(response) {
    if ("statusCode" in response) {
      let y = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("counts"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      let tempAC = this.decryptLocal("activeChannel");
      if (y.filter((x) => x.channelId === tempAC).length == 0) {
        y.push({
          channelId: tempAC,
          refreshedAt: Math.round(new Date().getTime() / 1000),
          counts: response.prospect_counts_channel,
        });
      } else {
        for (let i in y) {
          if (y[i]["channelId"] == tempAC) {
            y[i]["refreshedAt"] = Math.round(new Date().getTime() / 1000);
            y[i]["counts"] = response.prospect_counts_channel;
          }
        }
      }
      localStorage.setItem(
        "counts",
        CryptoJS.AES.encrypt(JSON.stringify(y), process.env.REACT_APP_PASS).toString()
      );

      this.props.dispatch({
        type: "CUST_UPDATE_QUERY_RESULT_JSON",
        filter_result_json: response.prospect_counts_channel,
      });
      this.props.dispatch({
        type: "CUST_UPDATE_OVERLAY_SPINNER",
        overlaySpinner: false,
      });
    }
  }

  prepareQueryResponse(response) {
    if ("final_result" in response) {
      let y = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("counts"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      let tempAC = this.decryptLocal("activeChannel");
      if (y.filter((x) => x.channelId === tempAC).length == 0) {
        y.push({
          channelId: tempAC,
          refreshedAt: Math.round(new Date().getTime() / 1000),
          counts: [JSON.parse(response["final_result"])],
        });
      } else {
        for (let i in y) {
          if (y[i]["channelId"] == tempAC) {
            y[i]["refreshedAt"] = Math.round(new Date().getTime() / 1000);
            y[i]["counts"] = [JSON.parse(response["final_result"])];
          }
        }
      }
      localStorage.setItem(
        "counts",
        CryptoJS.AES.encrypt(JSON.stringify(y), process.env.REACT_APP_PASS).toString()
      );

      this.props.dispatch({
        type: "CUST_UPDATE_QUERY_RESULT_JSON",
        filter_result_json: JSON.parse(response["final_result"]),
      });
      this.props.dispatch({
        type: "CUST_UPDATE_OVERLAY_SPINNER",
        overlaySpinner: false,
      });
    }
  }
  prepareQueryData(response) {
    let query_count = " ";
    let full_count = " ";
    let address_count = " ";
    let email_count = " ";
    let preview = [];
    let total_audience_email_count = " ";
    let total_audience_email_pre = " ";
    let total_audience_email_eclub = " ";
    let total_non_mkt = " ";
    let total_mkt = " ";
    let non_eclub_emails = " ";
    let non_preclub_emails = " ";
    let non_email_custs = " ";
    let non_direct_mail = " ";
    if (
      response["final_result"] !== undefined &&
      response["final_result"]["Items"] !== undefined &&
      response["final_result"]["Items"].length > 0 &&
      response["final_result"]["Items"][0]["_col0"] !== undefined
    ) {
      query_count = response["final_result"]["Items"][0]["_col0"];
    }
    if (
      response["full_result"] !== undefined &&
      response["full_result"]["Items"] !== undefined &&
      response["full_result"]["Items"].length > 0 &&
      response["full_result"]["Items"][0]["_col0"] !== undefined
    ) {
      full_count = response["full_result"]["Items"][0]["_col0"];
    }
    if (
      response["address_result"] !== undefined &&
      response["address_result"]["Items"] !== undefined &&
      response["address_result"]["Items"].length > 0 &&
      response["address_result"]["Items"][0]["_col0"] !== undefined
    ) {
      address_count = response["address_result"]["Items"][0]["_col0"];
    }
    if (
      response["email_result"] !== undefined &&
      response["email_result"]["Items"] !== undefined &&
      response["email_result"]["Items"].length > 0 &&
      response["email_result"]["Items"][0]["_col0"] !== undefined
    ) {
      email_count = response["email_result"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience"] !== undefined &&
      response["total_audience"]["Items"] !== undefined &&
      response["total_audience"]["Items"].length > 0 &&
      response["total_audience"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_count =
        response["total_audience"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience_pre"] !== undefined &&
      response["total_audience_pre"]["Items"] !== undefined &&
      response["total_audience_pre"]["Items"].length > 0 &&
      response["total_audience_pre"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_pre =
        response["total_audience_pre"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience_eclub"] !== undefined &&
      response["total_audience_eclub"]["Items"] !== undefined &&
      response["total_audience_eclub"]["Items"].length > 0 &&
      response["total_audience_eclub"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_eclub =
        response["total_audience_eclub"]["Items"][0]["_col0"];
    }
    if (
      response["total_non_mkt"] !== undefined &&
      response["total_non_mkt"]["Items"] !== undefined &&
      response["total_non_mkt"]["Items"].length > 0 &&
      response["total_non_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_non_mkt = response["total_non_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["total_mkt"] !== undefined &&
      response["total_mkt"]["Items"] !== undefined &&
      response["total_mkt"]["Items"].length > 0 &&
      response["total_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_mkt = response["total_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["non_eclub_emails"] !== undefined &&
      response["non_eclub_emails"]["Items"] !== undefined &&
      response["non_eclub_emails"]["Items"].length > 0 &&
      response["non_eclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_eclub_emails = response["non_eclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_preclub_emails"] !== undefined &&
      response["non_preclub_emails"]["Items"] !== undefined &&
      response["non_preclub_emails"]["Items"].length > 0 &&
      response["non_preclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_preclub_emails = response["non_preclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_email_custs"] !== undefined &&
      response["non_email_custs"]["Items"] !== undefined &&
      response["non_email_custs"]["Items"].length > 0 &&
      response["non_email_custs"]["Items"][0]["_col0"] !== undefined
    ) {
      non_email_custs = response["non_email_custs"]["Items"][0]["_col0"];
    }

    if (
      response["non_direct_mail"] !== undefined &&
      response["non_direct_mail"]["Items"] !== undefined &&
      response["non_direct_mail"]["Items"].length > 0 &&
      response["non_direct_mail"]["Items"][0]["_col0"] !== undefined
    ) {
      non_direct_mail = response["non_direct_mail"]["Items"][0]["_col0"];
    }
    if (
      response["preview_result"] != undefined &&
      response["preview_result"]["Items"] != undefined
    ) {
      preview = response["preview_result"]["Items"];
    }
    this.props.dispatch({
      type: "CUST_UPDATE_QUERY_COUNT",
      query_count: query_count,
      full_count: full_count,
      address_count: address_count,
      email_count: email_count,
      preview: preview,
      total_audience_email_count: total_audience_email_count,
      total_audience_email_pre: total_audience_email_pre,
      total_audience_email_eclub: total_audience_email_eclub,
      total_non_mkt: total_non_mkt,
      total_mkt: total_mkt,
      non_eclub_emails: non_eclub_emails,
      non_preclub_emails: non_preclub_emails,
      non_email_custs: non_email_custs,
      non_direct_mail: non_direct_mail,
    });
  }

  displayQuery() {
    this.props.dispatch({
      type: "CUST_SHOW_SPINNER",
      payload: "",
    });
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.cust_groupLeveltoggle;
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggle;
    let count = 0;
    let sqlAndOrOperator = "";
    let automationIdOrListId = "";
    let automationIdOrListIdExists = false;
    let prospectConditionExists = false;
    let menuItemsSelected = false;
    let menuSubCategorySelected = false;

    let modelDecileConditionExists = false;
    let modelDecileSelectedRule = "";
    let nonModelDecileSelectedRule = "";
    let samplingConditionExists = false;
    let samplingSelectedRule = "";

    if (this.props.cust_tillSqlSelectionArr.length !== 0) {
      this.props.cust_tillSqlSelectionArr.map((resultData, index) => {
        selectedRule += `(`;
        resultData.map((options, key) => {
          if (
            options.find((test) => test.value === "li.list_id") !== undefined
          ) {
            automationIdOrListIdExists = true;
          } else {
            automationIdOrListIdExists = false;
          }
          if (
            options.find((test) => test.value.includes("hh.")) !== undefined
          ) {
            prospectConditionExists = true;
          } else {
            prospectConditionExists = false;
          }
          if (
            options.find(
              (menuItem) =>
                menuItem.value ===
                "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id"
            ) !== undefined
          ) {
            menuItemsSelected = true;
          } else {
            menuItemsSelected = false;
          }

          if (
            options.find(
              (menuItemBajaFresh) =>
                menuItemBajaFresh.value ===
                "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id"
            ) !== undefined
          ) {
            menuItemsSelected = true;
          } else {
            menuItemsSelected = false;
          }

          if (
            options.find(
              (menuSubCategory) =>
                menuSubCategory.value ===
                "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where concat(item_hier_1, '-', item_hier_2)"
            ) !== undefined
          ) {
            menuSubCategorySelected = true;
          } else {
            menuSubCategorySelected = false;
          }

          if (
            options.find(
              (menuSubCategoryBajaFresh) =>
                menuSubCategoryBajaFresh.value ===
                "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id in (select item_id from bajafresh_refined.item where concat(item_hier_1, '-', item_hier_2)"
            ) !== undefined
          ) {
            menuSubCategorySelected = true;
          } else {
            menuSubCategorySelected = false;
          }

          if (
            options.find((test) => test.value.includes("model_decile")) !==
            undefined
          ) {
            modelDecileConditionExists = true;
          } else {
            modelDecileConditionExists = false;
          }

          if (
            options.find((rule) => rule.value.includes("Sampling")) !==
            undefined
          ) {
            samplingConditionExists = true;
          } else {
            samplingConditionExists = false;
          }

          let length = options.length;
          if (
            "value" in options[length - 2] &&
            options[length - 2].value.includes("+++")
          ) {
            options[length - 2].value = options[length - 2].value.split(
              "+++"
            )[0];
          }
          if (
            options[length - 1].value === "BETWEEN" ||
            options[length - 1].value === "NOT BETWEEN"
          ) {
            selectedRule += "(";

            if (modelDecileConditionExists) {
              modelDecileSelectedRule += "(";
            } else if (
              !modelDecileConditionExists &&
              !samplingConditionExists
            ) {
              nonModelDecileSelectedRule += "(";
            }

            if (samplingConditionExists) {
              samplingSelectedRule += "(";
            }
          }
          if (
            options[length - 1].value === "cardinality(array_intersect(" ||
            options[length - 1].value === "cardinality(array_except("
          ) {
            selectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";

            if (modelDecileConditionExists) {
              modelDecileSelectedRule +=
                "(" +
                options[length - 1].value +
                options[length - 2].value +
                ", array";
            } else if (
              !modelDecileConditionExists &&
              !samplingConditionExists
            ) {
              nonModelDecileSelectedRule +=
                "(" +
                options[length - 1].value +
                options[length - 2].value +
                ", array";
            }

            if (samplingConditionExists) {
              samplingSelectedRule +=
                "(" +
                options[length - 1].value +
                options[length - 2].value +
                ", array";
            }
          } else {
            selectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;

            if (modelDecileConditionExists) {
              modelDecileSelectedRule +=
                "(" +
                options[length - 2].value +
                " " +
                options[length - 1].value;
            } else if (
              !modelDecileConditionExists &&
              !samplingConditionExists
            ) {
              nonModelDecileSelectedRule +=
                "(" +
                options[length - 2].value +
                " " +
                options[length - 1].value;
            }

            if (samplingConditionExists) {
              samplingSelectedRule +=
                "(" +
                options[length - 2].value +
                " " +
                options[length - 1].value;
            }
          }
          let data = this.props.cust_afterSqlSelectionArr[index][key];
          if (data.length > 0) {
            data.map((result, resultKey) => {
              count = count + 1;
              sqlAndOrOperator = "";
              if (
                options[length - 1].value == "IN" ||
                options[length - 1].value == "NOT IN"
              ) {
                if (resultKey == 0) {
                  selectedRule += `(`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `(`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `(`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `(`;
                  }
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  if (automationIdOrListIdExists) {
                    automationIdOrListId = num;
                  }
                  if (typeof num == "string") {
                    selectedRule += ` '${result.value}', `;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` '${result.value}', `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` '${result.value}', `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` '${result.value}', `;
                    }
                  } else {
                    selectedRule += ` ${result.value}, `;

                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` ${result.value}, `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` ${result.value}, `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` ${result.value}, `;
                    }
                  }
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule = modelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule = samplingSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }

                  // selectedRule += `) AND ${JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("globalFilter"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // )} )`;

                  if (menuItemsSelected) {
                    selectedRule += `))) AND ${this.decryptLocal("globalFilter")} )`;
                  } else if (menuSubCategorySelected) {
                    selectedRule += `)))) AND ${this.decryptLocal("globalFilter")} )`;
                  } else {
                    selectedRule += `) AND ${this.decryptLocal("globalFilter")} )`;

                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += `) ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : "AND"
                      } ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : this.decryptLocal("globalFilter")
                      } )`;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += `) ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : "AND"
                      } ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : this.decryptLocal("globalFilter")
                      } )`;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += `) ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : "AND"
                      } ${
                        this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                          ? ""
                          : this.decryptLocal("globalFilter")
                      } )`;
                    }
                  }

                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== null &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;

                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` ${sqlAndOrOperator} `;
                    }
                  }
                } else {
                  let num = result.value;
                  if (automationIdOrListIdExists) {
                    automationIdOrListId = num;
                  }
                  if (typeof num == "string") {
                    selectedRule += ` '${result.value}', `;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` '${result.value}', `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` '${result.value}', `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` '${result.value}', `;
                    }
                  } else {
                    selectedRule += ` ${result.value}, `;

                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` ${result.value}, `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` ${result.value}, `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` ${result.value}, `;
                    }
                  }
                }
              } else if (
                options[length - 1].value == "cardinality(array_intersect("
              ) {
                if (resultKey == 0) {
                  selectedRule += `[`;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `[`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `[`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `[`;
                  }
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  let aggarray = [];
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule = modelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule = samplingSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }
                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  }
                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` ${sqlAndOrOperator} `;
                    }
                  }
                } else {
                  let num = result.value;
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                }
              } else if (
                options[length - 1].value == "cardinality(array_except("
              ) {
                if (resultKey == 0) {
                  selectedRule += `[`;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `[`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `[`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `[`;
                  }
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  let aggarray = [];
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule = modelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule = samplingSelectedRule.replace(
                      /,(\s+)?$/,
                      ""
                    );
                  }

                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `])) > 0 ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    })`;
                  }

                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += ` ${sqlAndOrOperator} `;
                    }
                  }
                } else {
                  let num = result.value;
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                }
              } else if (options[length - 1].value == "= ") {
                selectedRule += ` ${result.value} AND ${this.decryptLocal("globalFilter")})`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }
              } else {
                let num = result.value;
                if (
                  options[length - 1].value === "BETWEEN" ||
                  options[length - 1].value === "NOT BETWEEN"
                ) {
                  selectedRule += ` ${result.value}) AND ${this.decryptLocal("globalFilter")}),`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}) ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}) ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}) ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }
                } else if (typeof num == "string") {
                  selectedRule += ` '${result.value}' AND ${this.decryptLocal("globalFilter")}),`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}' ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}' ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}' ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }
                } else {
                  selectedRule += ` ${result.value} AND ${this.decryptLocal("globalFilter")}),`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value} ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value} ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value} ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : "AND"
                    } ${
                      this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                    }),`;
                  }
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }
                if (
                  ruleLeveltoggle.length > 0 &&
                  key !== resultData.length - 1 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              }
            });
          }
        });
        selectedRule += `)`;
        var position = selectedRule.indexOf(")(") + 1;
        let initalToggleRuleIndex = 0
        while (position > 0) {
          if (position > 0) {
            try {
              selectedRule = [
                selectedRule.slice(0, position),
                ` ${ruleLeveltoggle[index][initalToggleRuleIndex]} `,
                selectedRule.slice(position),
              ].join("");
            }
            catch(_) {
              selectedRule = [
                selectedRule.slice(0, position),
                ` AND `,
                selectedRule.slice(position),
              ].join("");
            }
            initalToggleRuleIndex += 1
          }
          position = selectedRule.indexOf(")(") + 1;
        }
        sqlAndOrOperator = "";
        if (
          groupLeveltoggle.length > 0 &&
          this.props.cust_tillSqlSelectionArr.length - 1 != index &&
          groupLeveltoggle[0] != undefined &&
          groupLeveltoggle[0][index] != undefined
        ) {
          sqlAndOrOperator = groupLeveltoggle[0][index];
          selectedRule += ` ${sqlAndOrOperator} `;
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          }

          if (samplingConditionExists) {
            samplingSelectedRule += ` ${sqlAndOrOperator} `;
          }
        }
        selectedRule = selectedRule.replace(/,(\s+)?$/, "");
        if (modelDecileConditionExists) {
          modelDecileSelectedRule = modelDecileSelectedRule.replace(
            /,(\s+)?$/,
            ""
          );
        } else if (!modelDecileConditionExists && !samplingConditionExists) {
          nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
            /,(\s+)?$/,
            ""
          );
        }

        if (samplingConditionExists) {
          samplingSelectedRule = samplingSelectedRule.replace(/,(\s+)?$/, "");
        }
      });
    }
    // Friday's Menu Filter changes

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '26'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '26'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '22'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '22'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '265'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '265'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '293'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '293'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '6'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '6'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '400'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '400'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '32'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '32'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '266'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '266'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '20'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '20'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '244'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '244'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '251'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '251'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '33'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '33'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '312'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '312'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '36'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '36'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '35'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '35'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '250'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '250'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '277'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '277'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '27'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '27'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '268'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '268'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '252'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '252'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '10'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '10'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '285'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '285'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '2'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '2'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '248'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '248'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '323'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '323'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '888'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '888'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '242'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '242'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '245'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '245'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '267'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '267'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '249'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '249'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '27' and item_hier_2 = '23'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '27' and item_hier_2 = '23'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '278'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '278'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '19'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '19'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '348'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '348'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '31'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '31'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '269'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '269'))) AND ca.geo_concept = '1'))"
    );

    // Redemptions Filter Changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    // Friday's Discount Sales Filter changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = false AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = true AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    let originaltext = selectedRule;
    let test = originaltext
      .split(
        "((ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = "
      )
      .pop();
    let final = test.replace("AND ca.geo_concept = '1'))", "");
    let test1 = final.replaceAll("'", "").split("AND")[0];
    let test2 = final.replaceAll("'", "").split("AND")[1];

    if (test1 !== "" && test1 !== undefined) {
      test1 = test1.trim();
    }

    if (test2 !== "" && test2 !== undefined) {
      test2 = test2.trim();
    }

    if (test1 !== null && test2 !== null) {
      // alert("Offer Code is :" + test1);
      // alert("Offer Code Duration is :" + test2);
      selectedRule = selectedRule.replace(
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',${test2},current_date) AND orig_template_id = '${test1}'))`
      );
      selectedRule = selectedRule.replace(
        `= '${test1} AND ${test2}' AND ca.geo_concept = '1'`,
        "AND ca.geo_concept = '1'"
      );
    }

    // console.log("Selected Rule is : " + selectedRule);
    // console.log("Model Decile Condition is : " + modelDecileSelectedRule);
    // console.log(
    //   "Non Model Decile Condition is : " + nonModelDecileSelectedRule
    // );

    let lastConditionProspect = modelDecileSelectedRule.slice(
      modelDecileSelectedRule.length - 4
    );
    if (lastConditionProspect.trim() == "AND") {
      modelDecileSelectedRule = modelDecileSelectedRule.slice(0, -4);
    }

    let lastConditionCustomer = nonModelDecileSelectedRule.slice(
      nonModelDecileSelectedRule.length - 4
    );
    if (lastConditionCustomer.trim() == "AND") {
      nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(0, -4);
      // nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(1);
    }

    let lastConditionSampling = samplingSelectedRule.slice(
      samplingSelectedRule.length - 4
    );
    if (lastConditionSampling.trim() == "AND") {
      samplingSelectedRule = samplingSelectedRule.slice(0, -4);
    }
    // console.log(
    //   "Model Decile After Removing Condition is : " + modelDecileSelectedRule
    // );
    // console.log(
    //   "Non Model Decile After Removing Condition is : " +
    //     nonModelDecileSelectedRule
    // );

    console.log(
      "Sampling Rule After Removing Condition is : " + modelDecileSelectedRule
    );

    let fQS = "";
    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    //Client Id's from cmp-clients table to use in the counts query

    let cmpClientIdObject = {
      "8c001fde-3728-48dc-9950-b8480ca9fbee": "33", // Baja Fresh
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b": "40", // ColdStoneCreamery
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799": "22", // Primanti Bro's
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f": "13", // Bad Daddy's
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534": "30", // Lou Malnatis
      "f0d3b19b-a564-43e9-85dd-bd95f8b13f97": "31", // Data Delivers Cafe / Data Delivers
      "52b86a20-91ae-457b-a6c7-f7708431b645": "1", // HouliHan's
      "19357b26-ddae-4b3a-9e95-b5879f1e9572": "32", // Uncle Julios
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9": "9", // SeaFood Grill
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406": "1", // HouliHan's NE
      "74d71e90-46e0-45b8-9b6e-a96883e85d54": "4", // Morton's
      "acf275e9-3f68-4250-9f8a-e80672b133f3": "43", // Pjwhelihans
      "7abec586-17b8-4174-993d-e3d86648ed60": "1", // HouliHan's CEN
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b": "29", // J.Gilbert's
      "c566b59a-7y94-4ag0-96cf-88av8084d1s3": "31", // Cogensia Cafe
      "687c8c2a-0986-4147-bf38-0d5bac9f7530": "36", // Eegee's
      "b44cc84d-73b5-4457-bb48-68e9626d08e1": "39", // Viva Chicken
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c": "38", // Brusters
      "535a90f3-b463-4d5a-9a83-39c522589a6c": "41", // Mambo
      "9501c9a1-6d0c-4285-a44f-64b1db4b3f91": "42", // Charleys
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534": "42", // Lous
      "e722fa14-9dbd-11ee-8c90-0242ac120002": "37", // ToC
      "31a73952-d1bf-4647-af62-204b1f56596c": "44", // Pollo Tropical
      "4d288e9e-9254-4513-bb54-072b9f8fc882": "45", // Flag Stop
      "d1522630-2b9d-424e-a399-7ab3f7be274f": "", // Lennys
      "7203dd51-f88b-4a4b-877c-92326d027915": "", // Planet Smoothie
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed": "", // Taco Time
      "cf6144d2-bb68-43b6-9876-dbf620b57c21": "", // Sweet Frog
      "37f97bea-f005-4be1-8e41-286ad79a7f3a": "48", // Bahamabucks
      "ec5a162e-5e87-4819-93bd-70bbf3b5f096": "47", // Brio Bravo
      "24ab940a-50d2-41fd-b3b2-c67ca6cb0304": "", // New Demo Client
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac": "49", // Bertucci
      "874b6c6a-83ff-480b-b615-1972538813ba": "50", // Bravo
      "b76e7818-deb1-4526-93a7-b398df3ea357": "27", // Goodtimes
      "e08840c5-c7d0-48c7-9c24-124b4cd80735": "51", // Ruby Tuesdays
      "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e": "52", // Firebirds
      "0bc2a383-9ae0-4e9e-9652-0fb762ba6119": "55", // Wow Car Wash
      "7bf99619-30a3-47a3-b1de-d72b4f7f99a7": "53", // Better Buzz
      "a4dda78e-7678-4aaf-9bef-60a229085fc8": "54", // Smoothie King
      // The client id needs to be added for Mambo in the above line after creating the record in the cmp-clients table
    };

    let countsStatement = this.decryptLocal("channelsAllObj").filter(
      (obj) =>
        obj.id ===
        this.decryptLocal("activeChannel")
    )[0]["counts"];

    // schemaName variable represents the database name (eg: {client_name.refined})
    let schemaName = this.decryptLocal("custDb");

    let globalFilter = this.decryptLocal("globalFilter");

    let selectedChannelId = this.decryptLocal("activeChannel");

    let selectedClientId = this.decryptLocal("clientId");


    let channelIdentity = "oe.email_address";
    let selectedProgram = "preclub";

    if (
      selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
      selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" ||
      selectedChannelId === "79b91604-9f03-428a-9026-9be77ca9a687"
    ) {
      // Display Channel
      channelIdentity = "di.name_addr_key";
      selectedProgram = "display";
    } else if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      // Preclub Channel
      channelIdentity = "oe.email_address";
      selectedProgram = "preclub";
    } else if (
      selectedChannelId === "g786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      selectedChannelId === "1d337d2d-e23a-445a-bda6-2405dbb79dcc" ||
      selectedChannelId === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" ||
      selectedChannelId === "3c8a9cf7-a0b2-4845-8436-d598181e6d78" ||
      selectedChannelId === "33bc71b1-4495-43f0-ab64-17ed38270e04"
    ) {
      // Loyalty Channel
      channelIdentity = "lo.loyalty_id";
      selectedProgram = "loyalty";
    } else if (
      selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
      selectedChannelId === "25c7cb9a-a192-46f5-b32d-49e8d52afea8" ||
      selectedChannelId === "92ec41c7-6724-4891-bc17-24981a3261dd" ||
      selectedChannelId === "c2a842ba-36cc-46b7-8fa4-3a361708b34b"
    ) {
      // Eclub Channel
      channelIdentity = "ec.email_address";
      selectedProgram = "eclub";
    } else if (selectedChannelId === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      // OLO Channel
      channelIdentity = "oc.email_address";
      selectedProgram = "olo";
    }

    // suppressionListCondition variable for suppressions functionality

    let suppressionListCondition = "";
    if (selectedChannelId !== "d1606aea-0c0d-4fba-83e8-a124f414a953" && selectedChannelId !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e") {
      suppressionListCondition = ` AND LOWER(${channelIdentity}) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions
        WHERE program = '${selectedProgram}') `;
    } else {
      suppressionListCondition = ` AND (LOWER(${channelIdentity}) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions) OR ${channelIdentity} is null)
       AND (LOWER(di.email) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions WHERE channel_identity is not null) OR di.email is null
      ) `;
    }

    let custIdToBeSuppressed = "";
    if (selectedClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534") {
      custIdToBeSuppressed = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("suppressionCustId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    }

    if (selectedCustomerType === "Customer") {
      if (selectedRule !== "") {
        if (
          selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
          selectedClientId === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
          selectedClientId === "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
          selectedClientId === "31a73952-d1bf-4647-af62-204b1f56596c" ||
          selectedClientId === "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
          selectedClientId === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
          selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
          selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
          selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
          selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
          selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
          selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
          selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
          selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
          selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
          selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
          selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
          selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
          selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
          selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
          selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
        ) {
          // GENERIC Display
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" || 
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
            ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id " +
              // Custom ToC
              ((selectedClientId !== "e722fa14-9dbd-11ee-8c90-0242ac120002") ?
              "LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept " 
              : '' ) +
              // Custom Coldstone Creamery
              "LEFT JOIN " +
              ((selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b")
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,geo_concept,loyalty_status, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2,3) lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")

            //  +
            // suppressionListCondition;
          } 
          // Loyalty - SMS
          else if (
            selectedChannelId === "33bc71b1-4495-43f0-ab64-17ed38270e04"
          ) {
            // Query for Loyalty Channel - CORDIAL
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (ca.geo_concept = '1') AND " +
              selectedRule +
              " AND lo.cust_id is not null AND (lo.loyalty_opt_out = false AND lo.sms_marketable = true)" +
              suppressionListCondition;
          } 
          // === CORDIAL ===
          else if (
            selectedChannelId === "3c8a9cf7-a0b2-4845-8436-d598181e6d78"
          ) {
            // Query for Loyalty Channel - CORDIAL
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              " AND lo.cust_id is not null AND lo.email_address is not null" +
              suppressionListCondition;
          } 
          else if (
            selectedChannelId === "c2a842ba-36cc-46b7-8fa4-3a361708b34b"
          ) {
            // Query for Eclub Channel - CORDIAL
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " + 
              " AND ec.cust_id is not null" +
              suppressionListCondition;
            if (selectedRule.includes("li.")) {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                selectedRule +
                " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " +
                " AND ec.cust_id is not null" +
                suppressionListCondition;
            }
          } else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
            selectedChannelId === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7"
          ) {
            // Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              " AND lo.cust_id is not null AND lo.email_address is not null" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
            selectedChannelId === "25c7cb9a-a192-46f5-b32d-49e8d52afea8"
          ) {
            // Query for Eclub Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " + 
              " AND ec.cust_id is not null" +
              suppressionListCondition;
            if (selectedRule.includes("li.")) {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                selectedRule +
                " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " +
                " AND ec.cust_id is not null" +
                suppressionListCondition;
            }
          } else {
            // Query for Preclub Channel
            if (selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" || 
                selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
                selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
                selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
                selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
                selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c") {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),false ,true) or client_complaints is null))) AND ` +
                this.decryptLocal("globalFilter") +
                " AND " +
                selectedRule +
                suppressionListCondition;
            } 
            // GUEST CONNECT + ToC Custom GC
            else {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                
                // CUSTOM ToC
                ((selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b")
                  ? schemaName +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                  : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                this.decryptLocal("globalFilter") +
                " AND " +
                selectedRule +
                suppressionListCondition;
            }
            // TODO : The below block could be removed
            if (selectedRule.includes("li.")) {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                selectedRule +
                suppressionListCondition;
            }
          }
        } else if (
          selectedClientId === "9501c9a1-6d0c-4285-a44f-64b1db4b3f91"
        ) {
          // Charleys Client
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Display Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
              
            // suppressionListCondition;
          } else if (
            selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "acf275e9-3f68-4250-9f8a-e80672b133f3"
        ) {
          // PJ Whelihan's Client
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Display Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
            // suppressionListCondition;
          } else if (
            selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "7abec586-17b8-4174-993d-e3d86648ed60" ||
          selectedClientId === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
          selectedClientId === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
          selectedClientId === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9"
        ) {
          // Houlihan's Brands
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            // Query for Preclub Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              suppressionListCondition;
          }
          else if(selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
            selectedChannelId === "79b91604-9f03-428a-9026-9be77ca9a687" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id " +
              // Custom ToC
              ((selectedClientId !== "e722fa14-9dbd-11ee-8c90-0242ac120002") ?
              "LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept " 
              : '' ) +
              // Custom Coldstone Creamery
              "LEFT JOIN " +
              ((selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b")
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,geo_concept,loyalty_status, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2,3) lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
          }
        } 
        else if (
          selectedClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
        ) {
          if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'"+
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
            // suppressionListCondition;
          } else {
            // Query for Loyalty Hubspot Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
        ) {
          // Friday's Client
          if (selectedChannelId === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            //Query for OLO Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'"+
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
            // suppressionListCondition;
          }
        } else if (
          selectedClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
          selectedClientId === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
        ) {
          // Lou Malnatis Client
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '88' ";
          } else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '68'";
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Lou Malnatis Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'"+
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
            // suppressionListCondition;
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          ) {
            //Eclub query
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
          }
        } else if (
          selectedClientId === "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534"
        ) {
          // Lous Client
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept ` + 
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              ` LEFT JOIN cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '88' ";
          } else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept " +
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              " WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '68'";
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Lous Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept " +
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              " LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              selectedRule +
              " AND di.audience_type = 'Customer'"+
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          ) {
            //Eclub query
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept " +
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              " LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              ' and ec.email_marketable = true '
          }
        } else if (
          (selectedClientId === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
            selectedClientId === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
            selectedClientId === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
            selectedClientId === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
            selectedClientId === "1857ba2f-010f-4f49-bcd1-f9fd09db2799") &&
          (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          )
        ) {
          //BadDaddys, Bruster's, PrimantiBros Display Channel
          // alert("Display channel Not Empty " + schemaName);
          fQS =
            "SELECT " +
            countsStatement +
            " FROM " +
            schemaName +
            ".display_customers di LEFT JOIN " +
            schemaName +
            ".cust_analytic ca ON di.cust_id = ca.cust_id " 
          
          // ===== PRIMANTI BROS CUSTOM ADDITION
          if(this.decryptLocal('clientId') === '1857ba2f-010f-4f49-bcd1-f9fd09db2799') {
            fQS += "left join primantibros_refined.model_scores_customer msc on ca.cust_id = msc.cust_id "
          }
          // =====

          fQS += " LEFT JOIN " +
            schemaName +
            ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            schemaName +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
            schemaName +
            ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
            globalFilter +
            " AND " +
            selectedRule +
            " AND di.audience_type = 'Customer'"+
            ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
          // suppressionListCondition;
        } else {
          // if (
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("clientId"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("activeChannel"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          // ) {
          //   fQS =
          //     "SELECT " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("channelsAllObj"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ).filter(
          //       (obj) =>
          //         obj.id ===
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("activeChannel"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         )
          //     )[0]["counts"] +
          //     " FROM " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".cust_analytic ca LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("globalFilter"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     " AND " +
          //     selectedRule +
          //     " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
          //     suppressionListCondition;
          //   // " AND ca.olo = true AND ca.loyalty = false";
          //   if (selectedRule.includes("li.")) {
          //     fQS =
          //       "SELECT " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("channelsAllObj"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).filter(
          //         (obj) =>
          //           obj.id ===
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("activeChannel"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //       )[0]["counts"] +
          //       " FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".cust_analytic ca LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).split("_")[0] +
          //       "_raw." +
          //       (JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("model"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) === "restaurant_v2"
          //         ? "lists_preclub"
          //         : "deliveries") +
          //       " li on li.cust_id = ca.cust_id WHERE " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("globalFilter"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       " AND " +
          //       selectedRule +
          //       " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
          //       suppressionListCondition;
          //     // " AND ca.olo = true AND ca.loyalty = false";
          //   }
          // } else if (
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("clientId"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("activeChannel"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
          // ) {
          //   fQS =
          //     "SELECT " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("channelsAllObj"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ).filter(
          //       (obj) =>
          //         obj.id ===
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("activeChannel"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         )
          //     )[0]["counts"] +
          //     " FROM " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".cust_analytic ca LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("custDb"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("globalFilter"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) +
          //     " AND " +
          //     selectedRule +
          //     " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
          //     suppressionListCondition;
          //   if (selectedRule.includes("li.")) {
          //     fQS =
          //       "SELECT " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("channelsAllObj"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).filter(
          //         (obj) =>
          //           obj.id ===
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("activeChannel"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //       )[0]["counts"] +
          //       " FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".cust_analytic ca LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).split("_")[0] +
          //       "_raw." +
          //       (JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("model"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) === "restaurant_v2"
          //         ? "lists_preclub"
          //         : "deliveries") +
          //       " li on li.cust_id = ca.cust_id WHERE " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("globalFilter"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       " AND " +
          //       selectedRule +
          //       " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
          //       suppressionListCondition;
          //   }
          // } else {
          // if (
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("clientId"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
          //   JSON.parse(
          //     CryptoJS.AES.decrypt(
          //       localStorage.getItem("clientId"),
          //       process.env.REACT_APP_PASS
          //     ).toString(CryptoJS.enc.Utf8)
          //   ) === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
          // ) {
          //   if (
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("activeChannel"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
          //     JSON.parse(
          //       CryptoJS.AES.decrypt(
          //         localStorage.getItem("activeChannel"),
          //         process.env.REACT_APP_PASS
          //       ).toString(CryptoJS.enc.Utf8)
          //     ) === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          //   ) {
          //     // Lou Malnatis Preclub / Eclub Channel
          //     fQS =
          //       "SELECT " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("channelsAllObj"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).filter(
          //         (obj) =>
          //           obj.id ===
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("activeChannel"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //       )[0]["counts"] +
          //       " FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".cust_analytic ca LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       // JSON.parse(
          //       //   CryptoJS.AES.decrypt(
          //       //     localStorage.getItem("custDb"),
          //       //     process.env.REACT_APP_PASS
          //       //   ).toString(CryptoJS.enc.Utf8)
          //       // ) +
          //       // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
          //       ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
          //       ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
          //         cmpClientIdObject[
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("clientId"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //         ]
          //       }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
          //         cmpClientIdObject[
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("clientId"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //         ]
          //       }'),false ,true) or client_complaints is null))) AND ` +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("globalFilter"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       " AND " +
          //       selectedRule +
          //       (JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("clientId"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
          //         ? suppressionListCondition
          //         : "");
          //     // + " AND ca.cust_id <> '88' ";
          //   } else {
          //     // alert("Lou Malnatis / Demo Other");
          //     if (
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("activeChannel"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
          //     ) {
          //       // Lou Malnatis Loyalty Channel
          //       fQS =
          //         "SELECT " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("channelsAllObj"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ).filter(
          //           (obj) =>
          //             obj.id ===
          //             JSON.parse(
          //               CryptoJS.AES.decrypt(
          //                 localStorage.getItem("activeChannel"),
          //                 process.env.REACT_APP_PASS
          //               ).toString(CryptoJS.enc.Utf8)
          //             )
          //         )[0]["counts"] +
          //         " FROM " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("custDb"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         ".cust_analytic ca LEFT JOIN " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("custDb"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("custDb"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //         // JSON.parse(
          //         //   CryptoJS.AES.decrypt(
          //         //     localStorage.getItem("custDb"),
          //         //     process.env.REACT_APP_PASS
          //         //   ).toString(CryptoJS.enc.Utf8)
          //         // ) +
          //         // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //         ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("custDb"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("custDb"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          //         JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("globalFilter"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) +
          //         " AND " +
          //         selectedRule +
          //         (JSON.parse(
          //           CryptoJS.AES.decrypt(
          //             localStorage.getItem("clientId"),
          //             process.env.REACT_APP_PASS
          //           ).toString(CryptoJS.enc.Utf8)
          //         ) !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
          //           ? suppressionListCondition
          //           : "");
          //       // + " AND ca.cust_id <> '68'";
          //     }
          //   }
          //   if (selectedRule.includes("li.")) {
          //     fQS =
          //       "SELECT " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("channelsAllObj"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).filter(
          //         (obj) =>
          //           obj.id ===
          //           JSON.parse(
          //             CryptoJS.AES.decrypt(
          //               localStorage.getItem("activeChannel"),
          //               process.env.REACT_APP_PASS
          //             ).toString(CryptoJS.enc.Utf8)
          //           )
          //       )[0]["counts"] +
          //       " FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".cust_analytic ca LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          //       // JSON.parse(
          //       //   CryptoJS.AES.decrypt(
          //       //     localStorage.getItem("custDb"),
          //       //     process.env.REACT_APP_PASS
          //       //   ).toString(CryptoJS.enc.Utf8)
          //       // ) +
          //       // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          //       ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("custDb"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ).split("_")[0] +
          //       "_raw." +
          //       (JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("model"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) === "restaurant_v2"
          //         ? "lists_preclub"
          //         : "deliveries") +
          //       " li on li.cust_id = ca.cust_id WHERE " +
          //       JSON.parse(
          //         CryptoJS.AES.decrypt(
          //           localStorage.getItem("globalFilter"),
          //           process.env.REACT_APP_PASS
          //         ).toString(CryptoJS.enc.Utf8)
          //       ) +
          //       " AND " +
          //       selectedRule +
          //       suppressionListCondition;
          //     // + " AND ca.cust_id <> '68'";
          //   }
          // } else {
          if (
            (this.decryptLocal('clientId') === "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
            this.decryptLocal('clientId') === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
            this.decryptLocal('clientId') === "19357b26-ddae-4b3a-9e95-b5879f1e9572" ||
            this.decryptLocal('clientId') === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
            this.decryptLocal('clientId') === "7abec586-17b8-4174-993d-e3d86648ed60" ||
            this.decryptLocal('clientId') === "74d71e90-46e0-45b8-9b6e-a96883e85d54" ||
            this.decryptLocal('clientId') === "52b86a20-91ae-457b-a6c7-f7708431b645" ||
            this.decryptLocal('clientId') === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
            this.decryptLocal('clientId') === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
            this.decryptLocal('clientId') === "c566b59a-7y94-4ag0-96cf-88av8084d1s3" ||
            this.decryptLocal('clientId') === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
            this.decryptLocal('clientId') === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
            this.decryptLocal('clientId') === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c") &&
            this.decryptLocal('activeChannel') === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" // GUEST CONNECT DEFAULT CHANNEL
          ) {
            console.log('GUEST CONNECT QUERY')
            fQS =
              "SELECT " +
              this.decryptLocal('channelsAllObj').filter((obj) =>obj.id === this.decryptLocal('activeChannel'))[0]["counts"] +
              " FROM " +
              this.decryptLocal('custDb') +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal('custDb') +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal('custDb') +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal('custDb') +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal('custDb') +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept "

              // ===== PRIMANTI BROS CUSTOM ADDITION
              if(this.decryptLocal('clientId') === '1857ba2f-010f-4f49-bcd1-f9fd09db2799') {
                fQS += "left join primantibros_refined.model_scores_customer msc on ca.cust_id = msc.cust_id "
              }
              // =====

              fQS += "LEFT JOIN " + this.decryptLocal('custDb') + ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[this.decryptLocal("clientId")]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints,'${
                cmpClientIdObject[this.decryptLocal("clientId")]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              (this.decryptLocal("clientId") !== "52b86a20-91ae-457b-a6c7-f7708431b645" &&
              this.decryptLocal("clientId") !== "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" &&
              this.decryptLocal("clientId") !== "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" &&
              this.decryptLocal("clientId") !== "74d71e90-46e0-45b8-9b6e-a96883e85d54" &&
              this.decryptLocal("clientId") !== "7abec586-17b8-4174-993d-e3d86648ed60" &&
              this.decryptLocal("clientId") !== "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" &&
              this.decryptLocal("clientId") !== "c566b59a-7y94-4ag0-96cf-88av8084d1s3" &&
              this.decryptLocal("clientId") !== "19357b26-ddae-4b3a-9e95-b5879f1e9572" &&
              this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition: "");
          } else {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              suppressionListCondition;
          }
          if (selectedRule.includes("li.")) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept left join " +
              this.decryptLocal("custDb").split("_")[0] +
              "_raw." +
              (JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("model"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              ) === "restaurant_v2"
                ? "lists_preclub"
                : "deliveries") +
              " li on li.cust_id = ca.cust_id WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              selectedRule +
              suppressionListCondition;
          }
        }
      } else {
        // Selected Rule is Empty
        if (
          selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
          selectedClientId === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
          selectedClientId === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
          selectedClientId === "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
          selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
          selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
          selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
          selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
          selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
          selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
          selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
          selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
          selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
          selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
          selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
          selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
          selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
          selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
          selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
        ) {
          // Kahala Client - Selected Rule Empty
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id " +
              // Custom ToC
              ((selectedClientId !== "e722fa14-9dbd-11ee-8c90-0242ac120002") ?
              "LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept " 
              : '' ) +
              " LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,geo_concept,loyalty_status, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2,3) lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'"+
              ((selectedChannelId === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")
            // suppressionListCondition;

          } 

          // Query for Loyalty Channel - SMS
          else if (
            selectedChannelId === "33bc71b1-4495-43f0-ab64-17ed38270e04"
          ) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (ca.geo_concept = '1') AND " +
              " AND lo.cust_id is not null AND (lo.loyalty_opt_out = false AND lo.sms_marketable = true)" +
              suppressionListCondition;
          } 
          else if (
            selectedChannelId === "3c8a9cf7-a0b2-4845-8436-d598181e6d78"
          ) {
            // Query for Loyalty Channel - CORDIAL
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              " AND lo.cust_id is not null AND lo.email_address is not null" +
              suppressionListCondition;
          } 
          else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
            selectedChannelId === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7"
          ) {
            // Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              " AND lo.cust_id is not null AND lo.email_address is not null" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
            selectedChannelId === "25c7cb9a-a192-46f5-b32d-49e8d52afea8" ||
            selectedChannelId === "c2a842ba-36cc-46b7-8fa4-3a361708b34b"
          ) {
            // Query for Eclub Channel & CORDIAL
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
              this.decryptLocal("globalFilter") +
              " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " +
              " AND ec.cust_id is not null" +
              suppressionListCondition;
          } else {
            // Query for Preclub Channel
            if (selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
              selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
              selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
              selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
              selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
              selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
              selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
              selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
              selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
              selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
              selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
              selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
              selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
              selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
              selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
              selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c") {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),false ,true) or client_complaints is null))) AND ` +
                this.decryptLocal("globalFilter") +
                suppressionListCondition;
            } else {
              fQS =
                "SELECT " +
                this.decryptLocal("channelsAllObj").filter(
                  (obj) =>
                    obj.id ===
                    this.decryptLocal("activeChannel")
                )[0]["counts"] +
                " FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                  : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                this.decryptLocal("globalFilter") +
                suppressionListCondition;
            }
          }
        } else if (
          selectedClientId === "9501c9a1-6d0c-4285-a44f-64b1db4b3f91"
        ) {
          // Charleys Client
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Display Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          } else if (
            selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "acf275e9-3f68-4250-9f8a-e80672b133f3"
        ) {
          // PJ Whelihans Client
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Display Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          } else if (
            selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "7abec586-17b8-4174-993d-e3d86648ed60" ||
          selectedClientId === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
          selectedClientId === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
          selectedClientId === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9"
        ) {
          // Houlihan's Brands
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            // Query for Preclub Channel
            fQS =
              "SELECT " +
              countsStatement +
              " FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              suppressionListCondition;
          }
        } 
        else if (selectedClientId === "e722fa14-9dbd-11ee-8c90-0242ac120002") {
          // ToC Display
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          }
          // ToC Eclub
          else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          ) {
            // Query for Eclub Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
              this.decryptLocal("globalFilter") +
              " AND (if(ec.email_marketable=true,false,true) = false AND ca.geo_concept = '1') " +
              " AND ec.cust_id is not null" +
              suppressionListCondition;
          }
          // ToC Email Channel
          else {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              suppressionListCondition;
          }
        }
        else if (
          selectedClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
        ) {
          if (selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
              selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          } else {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
              suppressionListCondition;
          }
        } else if (
          selectedClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
        ) {
          // Friday's Client
          if (selectedChannelId === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            //Query for OLO Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition;
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Query for Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          }
        } else if (
          selectedClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
          selectedClientId === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
        ) {
          // Lou Malnatis Client
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            // Preclub Query
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '88' ";
          } else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
            // + " AND ca.cust_id <> '68'";
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Lou Malnatis Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
            // suppressionListCondition;
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          ) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
          }
        } else if (
          selectedClientId === "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534"
        ) {
          // Lous Client
          if (selectedChannelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            // Preclub Query
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
          } else if (
            selectedChannelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
          ) {
            //Query for Loyalty Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              " AND (if(lo.email_marketable=true,false,true) = false AND ca.geo_concept = '1') AND " +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
          } else if (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
            // Lou Malnatis Display Channel
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'";
          } else if (
            selectedChannelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
          ) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "") +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'`;
          }
        } else if (
          (selectedClientId === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
            selectedClientId === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
            selectedClientId === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
            selectedClientId === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
            selectedClientId === "1857ba2f-010f-4f49-bcd1-f9fd09db2799") &&
          (
            selectedChannelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            selectedChannelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          )
        ) {
          //BadDaddys Display Channel
          // alert("Display channel Not Empty " + schemaName);
          fQS =
            "SELECT " +
            countsStatement +
            " FROM " +
            schemaName +
            ".display_customers di LEFT JOIN " +
            schemaName +
            ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
            schemaName +
            ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            schemaName +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
            schemaName +
            ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
            globalFilter +
            " AND di.audience_type = 'Customer'";
          // suppressionListCondition;
        } else {
          if (
            (this.decryptLocal("clientId") === "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
              this.decryptLocal("clientId") === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
              this.decryptLocal("clientId") === "19357b26-ddae-4b3a-9e95-b5879f1e9572" ||
              this.decryptLocal("clientId") === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
              this.decryptLocal("clientId") === "7abec586-17b8-4174-993d-e3d86648ed60" ||
              this.decryptLocal("clientId") === "74d71e90-46e0-45b8-9b6e-a96883e85d54" ||
              this.decryptLocal("clientId") === "52b86a20-91ae-457b-a6c7-f7708431b645" ||
              this.decryptLocal("clientId") === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
              this.decryptLocal("clientId") === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
              this.decryptLocal("clientId") === "c566b59a-7y94-4ag0-96cf-88av8084d1s3" ||
              this.decryptLocal("clientId") === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
              this.decryptLocal("clientId") === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
              this.decryptLocal("clientId") === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c") &&
            this.decryptLocal("activeChannel") === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints,'${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (this.decryptLocal("clientId") !== "52b86a20-91ae-457b-a6c7-f7708431b645" &&
              this.decryptLocal("clientId") !== "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" &&
              this.decryptLocal("clientId") !== "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" &&
              this.decryptLocal("clientId") !== "74d71e90-46e0-45b8-9b6e-a96883e85d54" &&
              this.decryptLocal("clientId") !== "7abec586-17b8-4174-993d-e3d86648ed60" &&
              this.decryptLocal("clientId") !== "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" &&
              this.decryptLocal("clientId") !== "c566b59a-7y94-4ag0-96cf-88av8084d1s3" &&
              this.decryptLocal("clientId") !== "19357b26-ddae-4b3a-9e95-b5879f1e9572" &&
              this.decryptLocal("clientId") !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
                ? suppressionListCondition
                : "");
          } else {
            fQS =
              "SELECT " +
              this.decryptLocal("channelsAllObj").filter(
                (obj) =>
                  obj.id ===
                  this.decryptLocal("activeChannel")
              )[0]["counts"] +
              " FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              suppressionListCondition;
          }
        }
        // else if (
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("clientId"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("activeChannel"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
        // ) {
        //   fQS =
        //     "SELECT " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("channelsAllObj"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ).filter(
        //       (obj) =>
        //         obj.id ===
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("activeChannel"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         )
        //     )[0]["counts"] +
        //     " FROM " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".cust_analytic ca LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("globalFilter"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
        //     suppressionListCondition;
        //   // " AND ca.olo = true AND ca.loyalty = false";
        // } else if (
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("clientId"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("activeChannel"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
        // ) {
        //   fQS =
        //     "SELECT " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("channelsAllObj"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ).filter(
        //       (obj) =>
        //         obj.id ===
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("activeChannel"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         )
        //     )[0]["counts"] +
        //     " FROM " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".cust_analytic ca LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("custDb"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     ".olo_customer oc on oc.cust_id = ca.cust_id WHERE " +
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("globalFilter"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) +
        //     " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
        //     suppressionListCondition;
        // } else if (
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("clientId"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        //   JSON.parse(
        //     CryptoJS.AES.decrypt(
        //       localStorage.getItem("clientId"),
        //       process.env.REACT_APP_PASS
        //     ).toString(CryptoJS.enc.Utf8)
        //   ) === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
        // ) {
        //   if (
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("activeChannel"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("activeChannel"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) === "3b3e90db-f06b-4ba4-9fbb-769637647ab0"
        //   ) {
        //     // Lou Malnatis Preclub / Eclub Channel
        //     fQS =
        //       "SELECT " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("channelsAllObj"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ).filter(
        //         (obj) =>
        //           obj.id ===
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("activeChannel"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //       )[0]["counts"] +
        //       " FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".cust_analytic ca LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //       // JSON.parse(
        //       //   CryptoJS.AES.decrypt(
        //       //     localStorage.getItem("custDb"),
        //       //     process.env.REACT_APP_PASS
        //       //   ).toString(CryptoJS.enc.Utf8)
        //       // ) +
        //       // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
        //       ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
        //       ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
        //         cmpClientIdObject[
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("clientId"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //         ]
        //       }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
        //         cmpClientIdObject[
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("clientId"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //         ]
        //       }'),false ,true) or client_complaints is null))) AND ` +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("globalFilter"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       (JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
        //         ? suppressionListCondition
        //         : "");
        //     // + " AND ca.cust_id <> '88' ";
        //   } else {
        //     // Lou Malnatis Loyalty Channel
        //     if (
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("activeChannel"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "f786cb0f-eecc-4b87-adef-34eb20f3f766"
        //     ) {
        //       fQS =
        //         "SELECT " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("channelsAllObj"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ).filter(
        //           (obj) =>
        //             obj.id ===
        //             JSON.parse(
        //               CryptoJS.AES.decrypt(
        //                 localStorage.getItem("activeChannel"),
        //                 process.env.REACT_APP_PASS
        //               ).toString(CryptoJS.enc.Utf8)
        //             )
        //         )[0]["counts"] +
        //         " FROM " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("custDb"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         ".cust_analytic ca LEFT JOIN " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("custDb"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("custDb"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //         // JSON.parse(
        //         //   CryptoJS.AES.decrypt(
        //         //     localStorage.getItem("custDb"),
        //         //     process.env.REACT_APP_PASS
        //         //   ).toString(CryptoJS.enc.Utf8)
        //         // ) +
        //         // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //         ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("custDb"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("custDb"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
        //         ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
        //         JSON.parse(
        //           CryptoJS.AES.decrypt(
        //             localStorage.getItem("globalFilter"),
        //             process.env.REACT_APP_PASS
        //           ).toString(CryptoJS.enc.Utf8)
        //         ) +
        //         suppressionListCondition;
        //       //  + " AND ca.cust_id <> '68'";
        //     }
        //   }
        // } else {
        //   if (
        //     (JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("clientId"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) === "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "19357b26-ddae-4b3a-9e95-b5879f1e9572" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "7abec586-17b8-4174-993d-e3d86648ed60" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "74d71e90-46e0-45b8-9b6e-a96883e85d54" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "52b86a20-91ae-457b-a6c7-f7708431b645" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "c566b59a-7y94-4ag0-96cf-88av8084d1s3" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c") &&
        //     JSON.parse(
        //       CryptoJS.AES.decrypt(
        //         localStorage.getItem("activeChannel"),
        //         process.env.REACT_APP_PASS
        //       ).toString(CryptoJS.enc.Utf8)
        //     ) === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
        //   ) {
        //     fQS =
        //       "SELECT " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("channelsAllObj"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ).filter(
        //         (obj) =>
        //           obj.id ===
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("activeChannel"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //       )[0]["counts"] +
        //       " FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".cust_analytic ca LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
        //       ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
        //         cmpClientIdObject[
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("clientId"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //         ]
        //       }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints,'${
        //         cmpClientIdObject[
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("clientId"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //         ]
        //       }'),false ,true) or client_complaints is null))) AND ` +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("globalFilter"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       (JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "52b86a20-91ae-457b-a6c7-f7708431b645" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "74d71e90-46e0-45b8-9b6e-a96883e85d54" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "7abec586-17b8-4174-993d-e3d86648ed60" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "c566b59a-7y94-4ag0-96cf-88av8084d1s3" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "19357b26-ddae-4b3a-9e95-b5879f1e9572" &&
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("clientId"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) !== "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
        //         ? suppressionListCondition
        //         : "");
        //   } else {
        //     fQS =
        //       "SELECT " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("channelsAllObj"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ).filter(
        //         (obj) =>
        //           obj.id ===
        //           JSON.parse(
        //             CryptoJS.AES.decrypt(
        //               localStorage.getItem("activeChannel"),
        //               process.env.REACT_APP_PASS
        //             ).toString(CryptoJS.enc.Utf8)
        //           )
        //       )[0]["counts"] +
        //       " FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".cust_analytic ca LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("custDb"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("globalFilter"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       ) +
        //       suppressionListCondition;
        //   }
        // }
      }
    }

    // Item History Changes
    if(fQS.includes("ih.item_id") || fQS.includes("ih.item_category")) {
      let newRegex = new RegExp(`FROM +${schemaName}.cust_analytic +ca *`, 'i')
      let newJoin = `FROM ${schemaName}.cust_analytic ca left join (select cust_id as "c_id", item_id, item_category from ${schemaName.split('_')[0]}_lookup.item_history) ih on ca.cust_id = ih.c_id `
      fQS = fQS.replace(newRegex, newJoin)

      newRegex = new RegExp(`FROM +${schemaName}.display_customers +di *`, 'i')
      newJoin = `FROM ${schemaName}.display_customers di left join (select cust_id as "c_id", item_id, item_category from ${schemaName.split('_')[0]}_lookup.item_history) ih on di.cust_id = ih.c_id `
      fQS = fQS.replace(newRegex, newJoin)
    }
    
    // fQS = fQS.replaceAll("ca.segment", "CAST(ca.segment AS varchar)");
    fQS = fQS.replaceAll("lo.loyalty_birthday = ", "");
    fQS = fQS.replaceAll("lo.loyalty_half_birthday = ", "");

    // Delivery File Suppression Changes:
    if (localStorage.getItem("automationSelectedId") !== null) {
      if (
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("model"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) === "restaurant_v3"
      ) {
        let currDb = this.decryptLocal("custDb")
        // IN
        let currRegex = /\( *li\.list_id +IN *\((.*?)\)/g;
        let currMatch = (' ' + fQS).slice(1).match(currRegex);
        let singleRegex, currAutomation
        if (currMatch) {
          let singleRegex = /\( *li\.list_id +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            fQS = fQS.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
        
        // NOT IN
        currRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/g;
        currMatch = (' ' + fQS).slice(1).match(currRegex);
        if (currMatch) {
          singleRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            fQS = fQS.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id NOT IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
      }
    }
    // V2 Clients?
    if (localStorage.getItem("automationSelectedId") !== null) {
      if (
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("model"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) === "restaurant_v2"
      ) {
  
        // JSON.parse(
        //   CryptoJS.AES.decrypt(
        //     localStorage.getItem("automationSelectedId"),
        //     process.env.REACT_APP_PASS
        //   ).toString(CryptoJS.enc.Utf8)
        // ) ISN't THE SAME AS currMatch[1]
  
        // NOT IN
        let currRegex = /\( *\( *li\.list_id +NOT +IN *\((.*?)\)/g;
        let currMatch = (' ' + fQS).slice(1).match(currRegex);
        let currDb = this.decryptLocal("custDb")
        if(currMatch) {
          let currAutomation = (' ' + currMatch[0]).slice(1).match(/\( *\( *li\.list_id +NOT +IN *\((.*?)\)/)
          fQS = fQS.replaceAll(
            currRegex,
            "((ca.cust_id NOT IN (select cust_id from " +
            currDb +
            ".lists_preclub where list_id IN (" +
            currAutomation[1] +
            "))"
          );
        }
  
        // IN
        currRegex = /\( *\( *li\.list_id +IN *\((.*?)\)/g;
        currMatch = (' ' + fQS).slice(1).match(currRegex);
        if(currMatch) {
          let currAutomation = (' ' + currMatch[0]).slice(1).match(/\( *\( *li\.list_id +IN *\((.*?)\)/)
          fQS = fQS.replaceAll(
            currRegex,
            "((ca.cust_id IN (select cust_id from " +
            currDb +
            ".lists_preclub where list_id IN (" +
            currAutomation[1]+
            "))"
          );
        }
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 46;
        if (i >= 10) {
          lastIndex = firstIndex + 47;
        }
        var updatedFQS =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = updatedFQS;
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_half_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 51;
        if (i >= 10) {
          lastIndex = firstIndex + 52;
        }
        var updatedFQS =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_half_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = updatedFQS;
      }
    }

    fQS = fQS.replaceAll(
      "((ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037' AND ca.geo_concept = '1'))",
      "ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037'))"
    );

    // Goodwill Enhancements Start

    fQS = fQS.replaceAll(
      "ca.member_tenure = true",
      "(ca.member_tenure >= 90 or ca.trans_ltd > 1)"
    );

    fQS = fQS.replaceAll(
      "ca.member_tenure = false",
      "(ca.member_tenure < 90 and ca.trans_ltd <= 1)"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 14",
      "ca.member_tenure = 14"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 7",
      "ca.member_tenure = 7"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 0",
      "ca.member_tenure = 0"
    );

    // if (
    //   this.state.localStorageClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
    // ) {
    //   fQS = fQS.replaceAll("geo.geo_active", "cast(geo.geo_active as boolean)");
    //   fQS = fQS.replaceAll(
    //     "if(lo.email_marketable=true,false,true)",
    //     "if(cast(lo.email_marketable as boolean)=true,false,true)"
    //   );
    // }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    ) {
      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "oc.email_marketable = true"
      );
      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "oc.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "lo.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "lo.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "92ec41c7-6724-4891-bc17-24981a3261dd"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "ec.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "ec.email_marketable = true"
      );
    }

    // DIS-ACQ Specific Changes

    if (
      (this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.decryptLocal("clientId") === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
        this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.decryptLocal("clientId") === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.decryptLocal("clientId") === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.decryptLocal("clientId") === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.decryptLocal("clientId") === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.decryptLocal("clientId") === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.decryptLocal("clientId") === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.decryptLocal("clientId") === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.decryptLocal("clientId") === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.decryptLocal("clientId") === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.decryptLocal("clientId") === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.decryptLocal("clientId") === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.decryptLocal("clientId") === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.decryptLocal("clientId") === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.decryptLocal("clientId") === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        this.decryptLocal("clientId") === "535a90f3-b463-4d5a-9a83-39c522589a6c") &&
      (
        this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
        this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
      )
    ) {
      fQS = fQS.replace("ca.dim_lifecycle", "di.dim_lifecycle");
      fQS = fQS.replace(
        "((ca.loyalty = false AND di.geo_concept = '1'))",
        "(((ca.loyalty = false OR ca.loyalty is null) AND di.geo_concept = '1'))"
      );
      fQS = fQS.replace("ca.geo_id_fav", "di.geo_id");
    }

    let queryToExecute = fQS;
    if (selectedCustomerType === "Acquistion") {
      if (
        this.props.cust_summaryDetails["filter_tab_details"]["condition"] ===
          "" ||
        this.props.cust_summaryDetails["filter_tab_details"]["condition"] !==
          fQS
      ) {
        this.fetchProspectQueryData(
          modelDecileSelectedRule,
          nonModelDecileSelectedRule,
          samplingSelectedRule
        );
      } else {
        if (
          this.props.cust_summaryDetails["filter_tab_details"]["value"] !==
          undefined
        ) {
          this.prepareQueryData(
            this.props.cust_summaryDetails["filter_tab_details"]["value"]
          );
        } else {
          this.fetchProspectQueryData(
            modelDecileSelectedRule,
            nonModelDecileSelectedRule,
            samplingSelectedRule
          );
        }
      }
    } else {
      if (
        this.props.cust_summaryDetails["filter_tab_details"]["condition"] ===
          "" ||
        this.props.cust_summaryDetails["filter_tab_details"]["condition"] !==
          fQS
      ) {
        this.fetchQueryData(queryToExecute);
      } else {
        if (
          this.props.cust_summaryDetails["filter_tab_details"]["value"] !==
          undefined
        ) {
          this.prepareQueryData(
            this.props.cust_summaryDetails["filter_tab_details"]["value"]
          );
        } else {
          this.fetchQueryData(queryToExecute);
        }
      }
    }
    // if (
    //   this.props.cust_summaryDetails["filter_tab_details"]["condition"] ===
    //     "" ||
    //   this.props.cust_summaryDetails["filter_tab_details"]["condition"] !== fQS
    // ) {
    //   this.fetchQueryData(queryToExecute);
    // } else {
    //   if (
    //     this.props.cust_summaryDetails["filter_tab_details"]["value"] !==
    //     undefined
    //   ) {
    //     this.prepareQueryData(
    //       this.props.cust_summaryDetails["filter_tab_details"]["value"]
    //     );
    //   } else {
    //     this.fetchQueryData(queryToExecute);
    //   }
    // }
  }

  render() {
    if (this.props.index === 0) {
      this.displayQuery();
    }
    const { classes } = this.props;
    let tillSqlSelectionArr = this.props.selectedValue;
    let afterSqlSelectionArr = this.props.cust_afterSqlSelectionArr[
      this.props.index
    ];
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    tillSqlSelectionArr.map((options, key) => {
      let length = options.length;
      selectedRule =
        "<strong>" +
        options[length - 2].label +
        "</strong> " +
        options[length - 1].label +
        " ";
      let data = afterSqlSelectionArr[key];
      // alert(JSON.stringify(selectedRule));
      if (data.length > 0) {
        data.map((result, key) => {
          if (
            options[length - 1].value == "IN" ||
            options[length - 1].value == "NOT IN"
          ) {
            if (key == 0) {
              selectedRule += ``;
            }
            selectedRule += `<strong> ${result.label} </strong>, `;
            if (key == data.length - 1) {
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              selectedRule += ``;
            }
          } else {
            if (
              result.label == "number_field_name" ||
              result.label == "string_field_name"
            ) {
              selectedRule += `<strong> ${result.value} <strong>, `;
            } else {
              selectedRule += `<strong> ${result.label} <strong>, `;
            }
          }
        });
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedResult.push(selectedRule);
    });
    let htmlContent = selectedResult.map((options, key) => (
      <li key={key}>
        <a
          href="javascript:void(0)"
          className="borderbtn"
          dangerouslySetInnerHTML={{ __html: options }}
        />
        <div className="editandclosespace">
          <Button
            style={{ textAlign: "center" }}
            className="btn btncreate editableicon"
            color="danger"
            onClick={() => this.deleteRuleClick(key)}
          >
            <i className="fa fa-trash" />
          </Button>
          <Modal
            titleName="Edit Rule"
            buttonLabel="Edit"
            selectedIndex={this.props.index}
            selectedRule={key}
            mode="Edit"
            type="rule"
            buttonType="edit button"
            class="editableicon"
          />
        </div>
        {selectedResult.length > 0 && selectedResult.length - 1 != key ? (
          <div
            className="andorbtngroupwrap"
            // <div className="andorbtngroupwrap parentwrap"
            //  style={{left: "-65px", marginTop:"10px", bottom:"-38px"}}
          >
            <div className="andorgroup">
              <ToggleButton
                selectedIndex={this.props.index}
                selectedRule={key}
                type="Rule"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </li>
    ));
    if (selectedRule !== "") {
      return (
        <React.Fragment>
          {/* <ul className="addrulelisting"> */}
          <ul
            className={
              htmlContent.length === 1 ? "addrulelisting-c" : "addrulelisting"
            }
          >
            {htmlContent}
          </ul>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {/* <ul className="addrulelisting"> */}
          <ul className={htmlContent.length === 1 ? "addrulelisting-c" : ""}>
            {htmlContent}
          </ul>
        </React.Fragment>
      );
    }
    // return (
    //   <React.Fragment>
    //     {/* <ul className="addrulelisting"> */}
    //     <ul
    //       className={
    //         htmlContent.length === 1 ? "addrulelisting-c" : "addrulelisting"
    //       }
    //     >
    //       {htmlContent}
    //     </ul>
    //   </React.Fragment>
    // );
  }
}

const mapStateToProps = (state) => ({
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  cust_summaryDetails: state.cust_summaryDetails,
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(AddRule)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/CCustomQueryBuilder/AddRule.jsx